<div *ngIf="allLoaded" class="container" [ngClass]="{'ionic': useIonic }">
    <!-- Header -->
    <div class="divSeccio header">
        <div class="search-pair">
            <input type="text" class="searchbox" placeholder="{{ 'SEARCH' | translate }}" [(ngModel)]="searchText" />
            <div class="searchbox-contadors">{{ getSelectedRoutesCount() }}</div>
        </div>
        <actions *ngIf="!showingSelectedRoutes" [actionstrip]="actions" (clickAction)="onClickAction($event)">
        </actions>
        <actions *ngIf="showingSelectedRoutes" [actionstrip]="confirmRoutesActions"
            (clickAction)="onClickAction($event)">
        </actions>
    </div>

    <div class="divSeccio header" *ngIf="showingSelectedRoutes">

        <div class="explanation" [innerHTML]="('BOOKINGPAGE.CONFIRMRELEASE.HELP' |
            translate: { routesCount: selectedRoutes.length }) | safe:'html'"></div>
    </div>

    <!-- Pendientes de gestionar -->
    <div class="divSeccio" *ngIf="routesPendingManage && routesPendingManage.length > 0 && !showingSelectedRoutes">
        <span class="title">{{ 'BOOKINGPAGE.ROUTESPENDINGMANAGE.CAPTION' | translate }}
            ({{routesPendingManage.length}})</span>
        <div class="routes">
            <shared-route-item-list
                *ngFor="let item of routesPendingManage | filterActiveRoutes:searchText:filterMetadataRoutesPendingManage | orderbyroutecarddto:true; let i=index"
                [route]="item" (click)="onSelectRoute(item)" class="routeItem monochrome"
                [selected]="selectedRoutes.includes(item.routeId)" (dblclick)="onDoubleClickRoute(item)">
            </shared-route-item-list>
        </div>
    </div>
    <!-- Gestionadas -->
    <div class="divSeccio" *ngIf="routesManaged && routesManaged.length > 0 && !showingSelectedRoutes">
        <span class="title">{{ 'BOOKINGPAGE.ROUTESMANAGED.CAPTION' | translate }}
            ({{routesManaged.length}})</span>
        <div class="routes">
            <shared-route-item-list
                *ngFor="let item of routesManaged | filterActiveRoutes:searchText:filterMetadataRoutesManaged | orderbyroutecarddto:true; let i=index"
                [selected]="selectedRoutes.includes(item.routeId)" (click)="onSelectRoute(item)"
                class="routeItem monochrome" (dblclick)="onDoubleClickRoute(item)" [route]="item">
            </shared-route-item-list>
        </div>
    </div>
    <!-- Cargadas -->
    <div class="divSeccio" *ngIf="routesDone && routesDone.length > 0 && !showingSelectedRoutes">
        <span class="title">{{ 'BOOKINGPAGE.ROUTESLOADED.CAPTION' | translate }}
            ({{routesDone.length}})</span>
        <div class="routes">
            <shared-route-item-list
                *ngFor="let item of routesDone | filterActiveRoutes:searchText:filterMetadataRoutesDone | orderbyroutecarddto:true; let i=index"
                [selected]="selectedRoutes.includes(item.routeId)" (click)="onSelectRoute(item)"
                class="routeItem monochrome" (dblclick)="onDoubleClickRoute(item)" [route]="item">
            </shared-route-item-list>
        </div>
    </div>

    <div class="divSeccio" *ngIf="showingSelectedRoutes">
        <shared-route-item-list
            *ngFor="let item of getSelectedRoutes() | filterActiveRoutes:searchText:filterMetadataRoutes | orderbyroutecarddto:true; let i=index"
            class="routeItem" [route]="item">
        </shared-route-item-list>

    </div>

</div>